import LocalizedStrings from "react-localization";

export const userPoolThumbnailsStrings = new LocalizedStrings({
  en: { selected: "Selected", outOf: "out of" },
  fr: { selected: "Selected", outOf: "out of" },
});
